module.exports = __webpack_public_path__ + "img/wechat_qr.cfa6486c.png";